<template>
  <form class="combination-form-root">
    <div class="form-fields">
        <div class="combination-main-section">
            <div> {{$t('match')}}: </div>
            <div class="combination-form-select" :class="{errors: formErrors.plateGroupType}">
                <label> {{$t('dish_type_group')}} *</label>
                <span class="field-error">{{formErrors.plateGroupType}}</span>
                <v-select aria-required="true" required 
                    class="v-select-field"
                    :getOptionLabel="o => `${o.CDGRTIPOPR} | ${o.NMGRTIPOPR}`"
                    :filterable="false" 
                    :options="plateGroupTypeOptions"
                    v-model="formData.selectedPlateGroupType"
                    @search:focus="onPlateGroupTypeSearch"
                    @input="clearChildren"
                    @search="onPlateGroupTypeSearch">
                </v-select>
            </div>
            <div class="field-group" :class="{errors: formErrors.topSection}">
                <span class="field-error">{{formErrors.topSection}}</span>
                <div class="combination-form-select no-margin-top">
                    <label> {{$t('group_of_dishes')}} </label>
                    <v-select
                        multiple
                        :getOptionLabel="o => `${o.CDGRUPOPRATO} | ${o.NMGRUPOPRATO}`"
                        :filterable="false" 
                        :options="plateGroupOptions"
                        v-model="formData.selectedPlateGroup"
                        @search:focus="(v, l) => onPlateGroupSearch(v, l, formData.selectedPlateGroupType)"
                        @input="validateExclusiveFieldSelection"
                        @search="(v, l) => onPlateGroupSearch(v, l, formData.selectedPlateGroupType)"
                        :closeOnSelect="false">
                    </v-select>
                </div>
                <div class="combination-form-select">
                    <label> {{$t('plates')}}</label>
                    <v-select 
                        multiple
                        :getOptionLabel="o => `${o.CDPRATO} | ${o.NMPRATO}`"
                        :filterable="false" 
                        :options="plateOptions"
                        v-model="formData.selectedPlate"
                        @search:focus="(v,l) => onPlateSearch(v, l, formData.selectedPlateGroupType)"
                        @input="validateExclusiveFieldSelection"
                        @search="(v,l) => onPlateSearch(v, l, formData.selectedPlateGroupType)"
                        :closeOnSelect="false">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="combination-sub-section">
            <div> {{$t('with')}}: </div>
            <div class="mode-switch">
                <div @click="switchMode('combination')" 
                    class="mode-switch-option"
                    :class="{active: mode === 'combination'}"> 
                {{$t('combination')}} </div>
                <div @click="switchMode('restriction')" 
                    class="mode-switch-option"
                    :class="{active: mode === 'restriction'}"> 
                {{$t('restriction')}} </div>
            </div>
            <div class="combination-form-select"  :class="{errors: formErrors.combinationPlateGroupType}">
                <label> {{$t('dish_type_group')}} *</label>
                <span class="field-error">{{formErrors.combinationPlateGroupType}}</span>
                <v-select 
                    class="v-select-field"
                    :getOptionLabel="o => `${o.CDGRTIPOPR} | ${o.NMGRTIPOPR}`"
                    :filterable="false" 
                    :options="plateGroupTypeOptions"
                    v-model="formData.combinationSelectedplateGroupType"
                    @search:focus="onPlateGroupTypeSearch"
                    @input="clearCombinationChildren"
                    @search="onPlateGroupTypeSearch">
                </v-select>
            </div>
            <div class="field-group" :class="{errors: formErrors.bottomSection}">
                <span class="field-error">{{formErrors.bottomSection}}</span>
                <div class="combination-form-select">
                    <label> {{$t('group_of_dishes')}} </label>
                    <v-select 
                        multiple
                        :getOptionLabel="o => `${o.CDGRUPOPRATO} | ${o.NMGRUPOPRATO}`"
                        :filterable="false" 
                        :options="plateGroupOptions"
                        v-model="formData.combinationSelectedPlateGroup"
                        @search:focus="(v,l) => onPlateGroupSearch(v, l, formData.combinationSelectedplateGroupType)"
                        @input="(v) => validateCombinationExclusiveFieldSelection(v, 'plateGroup')"
                        @search="(v,l) => onPlateGroupSearch(v, l, formData.combinationSelectedplateGroupType)"
                        :closeOnSelect="false">
                    </v-select>
                </div>
                <div class="combination-form-select">
                    <label> {{$t('plates')}} </label>
                    <v-select 
                        multiple
                        :getOptionLabel="o => `${o.CDPRATO} | ${o.NMPRATO}`"
                        :filterable="false" 
                        :options="plateOptions"
                        v-model="formData.combinationSelectedPlate"
                        @search:focus="(v,l) => onPlateSearch(v, l, formData.combinationSelectedplateGroupType)"
                        @input="(v) => validateCombinationExclusiveFieldSelection(v, 'plate')"
                        @search="(v,l) => onPlateSearch(v, l, formData.combinationSelectedplateGroupType)"
                        :closeOnSelect="false">
                    </v-select>
                </div>
                <div class="combination-form-select" v-if="mode === 'restriction'">
                    <label> {{$t('dish_type')}}</label>
                    <v-select 
                        :getOptionLabel="o => `${o.CDTIPOPRAT} | ${o.NMTIPOPRAT}`"
                        :filterable="false" 
                        :options="plateTypeOptions"
                        v-model="formData.combinationSelectedPlateType"
                        @search:focus="(v,l) => onPlateTypeSearch(v, l, formData.combinationSelectedplateGroupType)"
                        @input="(v) => validateCombinationExclusiveFieldSelection(v, 'plateType')"
                        @search="(v,l) => onPlateTypeSearch(v, l, formData.combinationSelectedplateGroupType)">
                    </v-select>
                </div>
            </div>
            <div class="combination-form-number-field" v-show="mode === 'combination'">
                <label> {{$t('reduction_percentage')}} </label>
                <input min="0" class="number-input" type="number" v-model="formData.PERCENTREDUCAO"/>
            </div>
        </div>
    </div>
    <div class="button-container"> 
        <button class="button ghost" @click="modal.hide('combination-form-modal')"> <i class="fas fa-times"></i> {{$t('cancel')}} </button>     
        <button type="submit" @click="saveCombination" class="button" style="font-size: 17px;"> <i class="fas fa-check"></i> {{$t('save')}} </button>
    </div>
  </form>
</template>

<script>
import vSelect from "vue-select";
import Provider from '@/application/providers/PlatesProvider'
import PlateService from '@/application/services/Plates'
import Util from '@/application/libs/util'
import { t } from 'i18next'

const requiredErrorMessage = t('required_field');
const atLeastOneErrorMessage = t('select_at_least_one_field');

export default {

  name: 'CombinationForm',

  props: ['modal'],

  components: {
    "v-select": vSelect
  },

  data() {
    return {
        plateGroupTypeOptions: [],
        combinationPlateGroupTypeOptions: [],
        plateGroupOptions: [],
        plateOptions: [],
        plateTypeOptions: [],
        mode: 'combination',
        formData: {
            combinationSelectedPlateType: null,
            combinationSelectedPlate: [],
            combinationSelectedPlateGroup: [],
            combinationSelectedplateGroupType: null,
            selectedPlate: [],
            selectedPlateGroup: [],
            selectedPlateGroupType: null,
            PERCENTREDUCAO: null
        },
        formErrors: {
            combinationPlateType: null,
            combinationPlate: null,
            combinationPlateGroup: null,
            combinationPlateGroupType: null,
            plate: null,
            plateGroup: null,
            plateGroupType: null,
            PERCENTREDUCAO: null,
            topSection: null,
            bottomSection: null
        }
    };
  },

  methods:{
    onVSelectSearch: function(query, _loading, dataSourceFn, optionsPropName, vm){
        _loading && _loading();
        dataSourceFn(query).then((result) => {
        vm[optionsPropName] = result;
        _loading && _loading();
        });
    },
    onPlateGroupTypeSearch: function(query, _loading) {
        this.onVSelectSearch(query, _loading, Provider.getPlateGroup, 'plateGroupTypeOptions', this);
    },
    onPlateGroupSearch: function(query, _loading, filterSource) {
        if(filterSource && filterSource.CDGRTIPOPR){
        const CDGRTIPOPR = filterSource.CDGRTIPOPR;
        this.onVSelectSearch(query, _loading, (q) => Provider.getPlateGroupForAutocomplete(q, CDGRTIPOPR), 'plateGroupOptions', this);
        }
    },
    onPlateSearch: function(query, _loading, filterSource) {
        if(filterSource && filterSource.CDGRTIPOPR){
            const CDGRTIPOPR = filterSource.CDGRTIPOPR;
            this.onVSelectSearch(query, _loading, (q) => Provider.getPlatesWithGruop(q, CDGRTIPOPR), 'plateOptions', this);
        }
    },
    onPlateTypeSearch: function(query, _loading, filterSource) {
        if(filterSource && filterSource.CDGRTIPOPR){
            const CDGRTIPOPR = filterSource.CDGRTIPOPR;
            this.onVSelectSearch(query, _loading, (q) => Provider.getPlateTypeForAutocomplete(q, CDGRTIPOPR), 'plateTypeOptions', this);
        }
    },
    validateExclusiveFieldSelection: function(newData) {
    if (this.formData.selectedPlate && this.formData.selectedPlate.length > 0 && 
        this.formData.selectedPlateGroup && this.formData.selectedPlateGroup.length > 0) {
            if (newData === this.formData.selectedPlate) {
                this.formData.selectedPlateGroup = [];
            } else {
                this.formData.selectedPlate = [];
            }
            Util.showNotification({ title: t('it_is_not_possible_to_select_dish_and_dish_group_simultaneously')});
        }
    },
    validateCombinationExclusiveFieldSelection: function(newData, from) {
        if(newData){
            if(from === 'plate'){
                this.formData.combinationSelectedPlate = [...newData];
                this.formData.combinationSelectedPlateGroup = [];
                this.formData.combinationSelectedPlateType = null;
            } else if(from === 'plateGroup'){
                this.formData.combinationSelectedPlateGroup = [...newData];
                this.formData.combinationSelectedPlateType = null;
                this.formData.combinationSelectedPlate = [];    
            } else if(from === 'plateType') {
                this.formData.combinationSelectedPlateType = {...newData};
                this.formData.combinationSelectedPlate = [];    
                this.formData.combinationSelectedPlateGroup = [];
            }
        }
        return true;
    },
    switchMode: function(newMode) {
        this.mode = newMode;
    },
    validateFields: function(data) {
        let isValid = true;
        (!data.CDGRTIPOPR || (this.formErrors.plateGroupType = null)) && (this.formErrors.plateGroupType = requiredErrorMessage) && (isValid = false);
        
        (!data.COMB_CDGRTIPOPR || (this.formErrors.combinationPlateGroupType = null)) && 
            (this.formErrors.combinationPlateGroupType = requiredErrorMessage) && (isValid = false);

        if(!data.GROUPPLATE && !data.PLATE){
            this.formErrors.topSection = atLeastOneErrorMessage;
            isValid = false;
        } else {
            this.formErrors.topSection = null
        }

        if((data.IDCOMBINACAO === 'RESTRICAO' && !data.COMB_GROUPPLATE && !data.COMB_PLATE && !data.COMB_CDTIPOPRAT) || 
        (data.IDCOMBINACAO === 'OBRIGATORIO' && !data.COMB_GROUPPLATE && !data.COMB_PLATE)){
            this.formErrors.bottomSection = atLeastOneErrorMessage;
            isValid = false;
        } else {
            this.formErrors.bottomSection = null
        }
        return isValid;
    },
    saveCombination: function() {
        const {
            combinationSelectedplateGroupType,              
            combinationSelectedPlateGroup, 
            combinationSelectedPlateType, 
            combinationSelectedPlate,
            selectedPlateGroupType,
            selectedPlateGroup,
            selectedPlate,
            PERCENTREDUCAO
        } = this.formData;

        const IDCOMBINACAO = this.mode === 'restriction' ? 'RESTRICAO' : 'OBRIGATORIO';

        const dataToSave = {
            CDGRTIPOPR: selectedPlateGroupType && selectedPlateGroupType.CDGRTIPOPR,
            PLATE: selectedPlate && selectedPlate.length > 0 ? selectedPlate : null,
            GROUPPLATE: selectedPlateGroup && selectedPlateGroup.length > 0 ? selectedPlateGroup : null,
            COMB_PLATE: combinationSelectedPlate && combinationSelectedPlate.length > 0 ? combinationSelectedPlate : null,
            COMB_GROUPPLATE: combinationSelectedPlateGroup && combinationSelectedPlateGroup.length > 0 ? combinationSelectedPlateGroup : null,
            COMB_CDGRTIPOPR: combinationSelectedplateGroupType && combinationSelectedplateGroupType.CDGRTIPOPR,
            COMB_CDTIPOPRAT: combinationSelectedPlateType && combinationSelectedPlateType.CDTIPOPRAT || null,
            IDCOMBINACAO,
            PERCENTREDUCAO: PERCENTREDUCAO || null,
        };

        dataToSave.COMB_CDTIPOPRAT = IDCOMBINACAO === "RESTRICAO" ? dataToSave.COMB_CDTIPOPRAT : null;
        dataToSave.PERCENTREDUCAO = IDCOMBINACAO === "OBRIGATORIO" ? dataToSave.PERCENTREDUCAO : null;

        const validationResult = this.validateFields(dataToSave);
        if(validationResult){
            PlateService.insertCombination(dataToSave)
            .then(keys => {
                this.$emit('combinationSaved');
                this.modal.hide('combination-form-modal');
            })
            .catch(e => {
                Util.showErrorNotification({ title: t('unable_to_save_combination'), text: e.error});
            });
        }
    },
    clearChildren: function(newData) {
        this.formData.selectedPlate = [];
        this.formData.selectedPlateGroup = [];
    },
    clearCombinationChildren: function(newData) {
        this.formData.combinationSelectedPlateType = null;
        this.formData.combinationSelectedPlate = [];
        this.formData.combinationSelectedPlateGroup = [];
    }
  }
};
</script>

<style lang="less">
    .v--modal-overlay .v-modal-overflow-visible{
        overflow: visible;
        background-color: white;
    }
    
    .combination-form-select{
        &.errors {
            .v-select-field .vs__dropdown-toggle{
                border: red solid 1px;
            }
        }
    }

</style>

<style lang="less" scoped>

.combination-form-select {
    /deep/ .vs__dropdown-toggle {
        min-height: 40px;
        max-height: 120px;
        overflow-y: auto;
        align-items: flex-start;
    }
    
    /deep/ .vs__selected {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }
}

.combination-form-root{
    margin: 10px;
    display: flex;
    flex-direction: column;

    .button-container{
        display: flex;
        justify-content: center;
        margin-bottom: 25px;


        .button{
            min-width: 100px;
            padding: 6px 15px;
            margin: auto 3px;

            &.ghost{
                background-color: white;
                box-shadow: none;
                color: #dc143d;
                border: 1px solid #dc143d;
                padding: 5px 14px;

                &:hover{
                    color: #212146;
                    border: 1px solid #212146;
                }
            }
        }
    }

    .mode-switch{
        margin-top: 10px;
        font-size: .9rem;
        border-radius: 5px;
        width: fit-content;
        color: #DC143D;
        border: 1px solid #DC143D;
        cursor: pointer;
        user-select: none;
        width: 100%;
        display: flex;

        .mode-switch-option{
            flex: 1;
            text-align: center;
            border-radius: 5px;
            padding: 7px;
            transition: .3s background-color;
            &:hover{
                background-color: #fcdee4;
            }

            &.active{
                background-color: #DC143D;
                color: white;
            }
        }
    }

    .combination-main-section{
        border-bottom: #20212424 1px solid;
        padding: 15px 19px;
        margin: 10px;

        .field-group{
            .field-error{
                font-size: .9rem;
                display: block;
                color: red;
                margin: 2.5px 0;
                min-height: 1rem;
            }

            &.errors{
                border: red 1px solid;
                margin-top: 10px;
                padding: 5px;
                border-radius: 5px;
            }
        }

    }

    .combination-sub-section{
        .combination-main-section;
        margin-top: 0;
        border: none; 
    }

    .combination-form-field{

        &.margin-top-20{
            margin-top: 20px;
        }

        &.no-margin-top{
            margin-top: 0;
        }

        margin-top: 10px;


        label{
            width: 200px;
            text-align: right;
        }

        .field-error{
            font-size: .9rem;
            display: block;
            color: red;
            margin: 2.5px 0;
            min-height: 1rem;
        }

    }

    .combination-form-select{
            
        
        .combination-form-field;
        .v-select {
            margin-top: 1px;
        }
    }

    .combination-form-number-field{
        .combination-form-field;

        .number-input{
            appearance: none;
            outline: none;
            border: 1px solid;
            padding: 5px 0 6px 8px;
            background: none;
            border: 1px solid #c4c4c4;
            border-radius: 4px;
            display: block;
            width: calc(100% - 8px);
            font-size: 1em;
            color: #333346;
            line-height: 1.4;
        }
    }
}

</style>